import { breakpoints } from "./breakpoints";

(function ($) {

    $(function () {


        setTimeout(function () {

            const $inputFields = $('.wp-color-picker');

            $inputFields.each(function () {
                const $input = $(this);

                $input.on('focus', function () {
                    $(this).closest('.wp-picker-container').find('.iris-picker').hide();
                });

                $(document).on('click', function (e) {
                    if (!$(e.target).closest('.list').length) {
                        $('.list').removeClass('-active');
                    }
                });
            });

        }, 1000);

    });

} ) ( jQuery );